import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import AlertProps from '../../@types/Alert.type';
import './alert.scss';
import { Alert } from '../../enums/enum';
import parse from 'html-react-parser';
import { useAppSelector } from '../../store/store';
import { motion } from 'framer-motion';

const AlertWrapper: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <motion.div
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ type: 'spring', stiffness: 60, duration: 0.2 }}
  >
    <Box
      pl={{ xs: 4, md: 10 }}
      pr={{ xs: 4, md: 10 }}
      mt={5}
      boxSizing="border-box"
    >
      <Box
        boxShadow="0px -2px 10px #cbced1, 0px 10px 10px #cbced1"
        borderRadius="0.375rem"
      >
        {children}
      </Box>
    </Box>
  </motion.div>
);

const AlertComponent: React.FC<AlertProps> = ({ type, message, error }) => {
  const { flightNumber, flightOrigin } = useAppSelector(
    (state) => state.appStateReducer,
  );

  // Scroll to top of page whenever there is an error or validation error
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [message, message?.length, type, error]);

  if (type === Alert.ERROR)
    return (
      <AlertWrapper>
        <auro-alert type={type}>
          <b id="error-title">Application Error : </b>
          <br />
          <b>{message}</b>
          <br />
          <hr />
          Please contact{' '}
          <a href="mailto:its.service.desk@alaskaair.com">
            ITS.Service.Desk@alaskaair.com
          </a>{' '}
          for further troubleshooting.
          {/* Tell user to use tthe Backup Briefing Packet */}
          If this problem is not resolved in a timely manner, try using the{' '}
          <a
            target="blank"
            href="https://fogs.insideaag.com/jetstream/JetStream.asp"
          >
            Jetstream Backup site
          </a>
          <br />
          <br />
        </auro-alert>
      </AlertWrapper>
    );

  if (type === Alert.WEATHEROVERRIDEERROR) {
    return (
      <AlertWrapper>
        <auro-alert type="error">
          {/* The message passed as string which will contain HTML, that needs tobe parsed to HTML */}
          {parse(message as string)}
          <br />
        </auro-alert>
      </AlertWrapper>
    );
  }

  if (type === Alert.SUCCESS) {
    return (
      <AlertWrapper>
        <auro-alert type="success">
          <b id="success-title">Successfull Request !!</b>
          <p>
            Successfully created packet for flight {flightNumber} from{' '}
            {flightOrigin}
          </p>
        </auro-alert>
      </AlertWrapper>
    );
  }

  // Validation error (warning) fallback
  return (
    <AlertWrapper>
      <auro-alert type={type}>
        <b id="validaion-title">Validation Error : </b>
        <ol>
          {/* Say message = Please select the Station from the list in Step 1,Please select the Printer from the list in Step 1, */}
          {message
            ?.split(',') // ['Please select the Station from the list in Step 1', 'Please select the Printer from the list in Step 1', '']
            ?.filter((msg) => msg !== '') // Remove the empty string from the array ['Please select the Station from the list in Step 1', 'Please select the Printer from the list in Step 1']
            ?.map(
              (
                msg, // Render the message list
              ) => <li key={msg}>{msg}</li>,
            )}
        </ol>
      </auro-alert>
    </AlertWrapper>
  );
};

export default AlertComponent;
